import "@/app/i18n";

import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router";
import { AppErrorBoundary } from "@/shared/components";
import { installConsoleBuffer } from "@/shared/support";
import { registerChunkReloadGuard } from "./registerChunkReloadGuard";
import { AppRouter } from "./router";
import { store } from "./store";
import "@/shared/assets/css/globals.css";

registerChunkReloadGuard();
installConsoleBuffer();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <AppErrorBoundary>
    <Provider store={store}>
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </Provider>
  </AppErrorBoundary>,
);
